import { fetchData } from "./fetch";

export const getUserLocation = async () => {
  const res = await fetchData("GET", "", {}, {}, {}, "https://ipapi.co/json");
  const { country, city, country_code, country_name, latitude, longitude } =
    res;
  return {
    country,
    country_code,
    country_name,
    latlong: `${latitude},${longitude}`,
    city,
  };
};
